import { NavLink, useLocation } from 'react-router-dom'
import { FC, MouseEvent, useCallback, useEffect, useState } from 'react'
import { AnimatePresence } from 'framer-motion'

import { IconClose } from 'components/icons/close-icon'
import { Share } from '../share'
import { MenuIcon } from './icons/menu-icon'
import { useMenuContext } from './menu-context'
import { usePlayerContext } from 'context/player-context'
import { useDigitsContext } from 'context/digits-context'
import { HomeIcon } from './icons/home-icon'
import { VideoIcon } from './icons/video-icon'
import { InfoIcon } from './icons/info-icon'
import { CalendarIcon } from './icons/calendar-icon'
import {
  Li,
  MenuList,
  MenuToggle,
  MenuWrapper,
  ScrollContainer,
  Social,
  Years,
} from './styled'
import { menuVariants, yearsVariants } from './variants'

export const Toggle = () => {
  const { isOpen, toggleMenu, closeMenu } = useMenuContext()
  const { pathname } = useLocation()

  useEffect(() => {
    if (isOpen) {
      closeMenu()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  return (
    <>
      <MenuToggle onClick={toggleMenu} aria-label="Toggle menu">
        {isOpen ? <IconClose /> : <MenuIcon />}
      </MenuToggle>
    </>
  )
}

export const Menu: FC = () => {
  const { isOpen } = useMenuContext()
  const [yearsExpanded, setYearsExpanded] = useState(false)
  const { radioProgress } = usePlayerContext()
  const { mapYearToCoords } = useDigitsContext()

  const linkClickHandler = useCallback(
    (year: number | string) => {
      const newValue = mapYearToCoords(String(year))

      if (newValue) {
        radioProgress.set(newValue)
      }
    },
    [radioProgress, mapYearToCoords],
  )

  useEffect(() => {
    document.body.classList[isOpen ? 'add' : 'remove']('locked')
  }, [isOpen])

  const toggleYears = (evt: MouseEvent) => {
    evt.preventDefault()
    setYearsExpanded(v => !v)
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <MenuWrapper
          variants={menuVariants}
          initial="initial"
          animate="enter"
          exit="exit"
        >
          <ScrollContainer>
            <MenuList>
              <Li>
                <NavLink to="/">
                  {' '}
                  <HomeIcon /> На главную
                </NavLink>
              </Li>
              <Li>
                <NavLink to="/video">
                  <VideoIcon /> Видеофайлы
                </NavLink>
              </Li>
              <Li>
                <NavLink to="/year" onClick={toggleYears}>
                  <CalendarIcon /> Программы по годам
                </NavLink>

                <AnimatePresence initial={false}>
                  {yearsExpanded && (
                    <Years
                      variants={yearsVariants}
                      initial="initial"
                      animate="enter"
                      exit="exit"
                    >
                      {[...Array(70)].map((_, i) => (
                        <li key={i}>
                          <NavLink to={`/year/${1953 + i}`} onClick={() => linkClickHandler(1953 + i)}>{1953 + i}</NavLink>
                        </li>
                      ))}
                    </Years>
                  )}
                </AnimatePresence>
              </Li>
              <Li>
                <NavLink to="/about">
                  <InfoIcon /> о проекте
                </NavLink>
              </Li>
            </MenuList>

            <Social>
              ПОДЕЛИСЬ ПРОЕКТОМ
              {/*<SocialMenu />*/}
              <Share />
            </Social>
          </ScrollContainer>
        </MenuWrapper>
      )}
    </AnimatePresence>
  )
}
